import React, { useState } from "react";
import { useTheme } from "../../../../../hooks";
import { checkForActive } from "../../../../../utils";
import { getWindow } from "../../../../../utils/WindowUtil";
import { Icon } from "../../../../icon";
import CustomLink from "../../shared/link/CustomLink";
import { NavItemContainer } from "./NavItemStyles";
const NavItem = ({ name, to, active, icon, iconCategory, onClick, customLinkComponent }) => {
    const location = getWindow()?.location;
    const { Theme } = useTheme();
    const [hovered, setHovered] = useState(false);
    const itemActive = active || (!!to ? checkForActive(location, to) : false);
    const Content = () => (React.createElement(NavItemContainer, { onClick: onClick, active: itemActive, onMouseOver: () => setHovered(true), onMouseLeave: () => setHovered(false) },
        !!icon && (React.createElement(Icon, { className: "me-2", iconName: icon, iconCategory: iconCategory, styles: {
                color: hovered
                    ? Theme.nav.mobile.hover.color
                    : itemActive
                        ? Theme.nav.mobile.active.color
                        : Theme.nav.mobile.link.color,
                hoverColor: Theme.nav.mobile.hover.color,
            } })),
        name));
    return !!to ? (React.createElement(CustomLink, { to: to, customLinkComponent: customLinkComponent },
        React.createElement(Content, null))) : (React.createElement(Content, null));
};
export default NavItem;
//# sourceMappingURL=NavItem.js.map